


























































import Vue from 'vue'
import Component from 'vue-class-component'
import GoBack from '@/components/GoBack.vue'
import Card from '@/components/Card.vue'
import PdfViewer from '@/components/PdfViewer.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { LettersModule } from '@/store/modules/letters.module'
import ScrollView from '@/components/ScrollView.vue'
import { LETTERS_MAILABLE_STATUSES, LETTERS_MAILED_STATUSES } from '@/constants'
import Icon from '@/components/Icon.vue'
import { ILetter, IResident } from '@zunta/configurations'
import LetterResidentContact from '@/views/app/management/review-letters/components/LetterResidentContact.vue'
import BatchSuccessModal from '../review-statements/components/BatchSuccessModal.vue'

@Component({
  components: { LetterResidentContact, Icon, ScrollView, PdfViewer, Card, GoBack, BatchSuccessModal }
})
export default class ReviewLetters extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  letterModuleInstance: LettersModule = getModule(LettersModule, this.$store)

  isLoading: boolean = false

  get mailedStatuses () {
    return LETTERS_MAILED_STATUSES
  }

  get selectedLetter () {
    return this.$store.state.letter.selectedLetter
  }

  get src () {
    return this.selectedLetter ? this.selectedLetter.pdf : null
  }

  get letterList () {
    return this.$store.state.letter.letterList
  }

  get letterId () {
    return this.$route.params.letter
  }

  get batchId () {
    return this.$route.params.batch
  }

  get type () {
    return this.$route.params.type
  }

  get resident () {
    return this.selectedLetter ? this.selectedLetter.resident : null
  }

  get residentContacts () {
    return this.$store.state.resident.residentContacts
  }

  get residentLetters () {
    if (!this.resident) {
      return []
    }
    return this.letterList.filter((letter: ILetter) => Number((letter.resident as IResident).id) === Number(this.resident.id))
  }

  get ableToSeePrevResident () {
    const indexes = this.calcCurrentResidentStatementsIndexes()
    let newIndex = indexes.pop() + 1
    return !isNaN(newIndex) && this.letterList[newIndex]
  }

  get ableToSeeNextResident () {
    const indexes = this.calcCurrentResidentStatementsIndexes()
    let newIndex = indexes[0] - 1
    return !isNaN(newIndex) && this.letterList[newIndex]
  }

  async letterStatusChanged () {
    await this.letterModuleInstance.fetchLettersBatchStatistics(this.batchId)
    const letterStats = this.letterModuleInstance.lettersStatistics
    if (letterStats && LETTERS_MAILABLE_STATUSES.every(mailableStatus => !letterStats[mailableStatus])) {
      this.showSuccessModal()
    }
  }

  mounted () {
    this.fetchData()
  }

  async fetchData () {
    try {
      this.setLoadingState(true)
      await this.letterModuleInstance.fetchBatchLettersByFilters({ batchId: this.batchId, filters: {} })
      await this.letterModuleInstance.fetchLetterById(this.letterId)
      if (!this.type) {
        const type = this.selectedLetter && !this.mailedStatuses.includes(this.selectedLetter.status) ? 'unmailed' : 'mailed'
        await this.$router.push({
          name: 'review-letters',
          params: {
            batch: this.batchId.toString(),
            letter: this.$route.params.letter,
            type: type
          }
        })
      }

      await this.residentModuleInstance.fetchResidentContacts((this.resident as IResident).id)
    } finally {
      this.setLoadingState(false)
    }
  }

  setLoadingState (loading: boolean) {
    this.isLoading = loading
    if (this.isLoading) {
      this.$eventBus.$emit('loading:enable', { message: 'Loading' })
      return
    }

    setTimeout(() => {
      this.$eventBus.$emit('loading:disable')
    }, 200)
  }

  calcCurrentResidentStatementsIndexes () {
    if (!this.selectedLetter || (!this.letterList || !this.letterList.length)) {
      return []
    }
    return this.letterList.flatMap((item: any, index: number) => {
          // @ts-ignore
          return this.selectedLetter.resident.id === item.resident.id ? index : []
        }
    )
  }

  async goToLetter (letterId: string | number) {
    await this.$router.push({
      name: 'review-letters',
      params: {
        batch: this.batchId.toString(),
        letter: letterId.toString(),
        type: this.type
      }
    })
    await this.fetchData()
  }

  prevResident () {
    if (!this.ableToSeePrevResident) {
      return
    }
    let newIndex = this.calcCurrentResidentStatementsIndexes()[0] - 1
    if (newIndex && this.letterList[newIndex]) {
      this.goToLetter(this.letterList[newIndex].id)
    }
  }

  nextResident () {
    if (!this.ableToSeeNextResident) {
      return
    }
    let newIndex = this.calcCurrentResidentStatementsIndexes().pop() + 1
    if (newIndex && this.letterList[newIndex]) {
      this.goToLetter(this.letterList[newIndex].id)
    }
  }

  get isShowSuccessModal () {
    return this.letterModuleInstance.isShowSuccessModal
  }

  showSuccessModal () {
    return this.letterModuleInstance.showSuccessModal()
  }

  closeSuccessModal () {
    return this.letterModuleInstance.closeSuccessModal()
  }
}
